import FJFontFamilyContainer from "../../toolBar/view/FJFontFamilyContainer";
import React from "react";
import styles from './FJWatermarkFont.module.less'

function FJWatermarkFont(props) {
  const {loadingFonts, fontFamily, fontFamilyList, fontFamilyChange} = props;
  return (
    <FJFontFamilyContainer loadingFonts={loadingFonts}
                           className={styles.font_btn}
                           dropDownClassName={styles.dropdown}
                           previewClassName={styles.preview}
                           fontFamily={fontFamily}
                           fontFamilyList={fontFamilyList}
                           fontFamilyChange={fontFamilyChange}

    />
  );
}

export default FJWatermarkFont;
